module.exports = __webpack_public_path__ + "img/gaotie.07ce5f26.png";